import api from './api'

export const accesoMascotasService = {
  /**
   * DUEÑO: Genera un acceso temporal (token/código) para compartir mascotas.
   * @param {{ mascotas:number[], alcance?:string, duracion_minutos?:number }} data
   */
  async create(data) {
    const response = await api.post('/acceso-mascotas', data)
    return response.data
  },

  /**
   * VET/ADMIN/SUPERADMIN: Valida token o código y obtiene acceso a mascotas.
   * @param {{ token?:string, codigo?:string }} data
   */
  async validar(data) {
    const response = await api.post('/acceso-mascotas/validar', data)
    return response.data
  },

  /**
   * DUEÑO: Revoca un acceso por id.
   */
  async revocar(idAcceso) {
    const response = await api.post(`/acceso-mascotas/${idAcceso}/revocar`)
    return response.data
  },

  /**
   * PET_SITTER: postularse como cuidador para una mascota compartida temporalmente.
   * @param {{ token?:string, codigo?:string, id_mascota:number|string, mensaje?:string }} data
   */
  async postular(data) {
    const response = await api.post('/acceso-mascotas/postulaciones', data)
    return response.data
  },

  /**
   * DUEÑO/SUPERADMIN: listar postulaciones de cuidadores.
   * @param {{ id_mascota?:number|string, id_acceso?:number|string }} params
   */
  async listarPostulaciones(params = {}) {
    const response = await api.get('/acceso-mascotas/postulaciones', { params })
    return response.data
  },

  /**
   * DUEÑO/SUPERADMIN: aprobar postulación.
   */
  async aprobarPostulacion(idPostulacion) {
    const response = await api.post(`/acceso-mascotas/postulaciones/${idPostulacion}/aprobar`)
    return response.data
  },

  /**
   * DUEÑO/SUPERADMIN: rechazar postulación.
   */
  async rechazarPostulacion(idPostulacion) {
    const response = await api.post(`/acceso-mascotas/postulaciones/${idPostulacion}/rechazar`)
    return response.data
  },
}

